import { Container, interfaces } from 'inversify';
import {
    AuditServiceContract,
    ConfigServiceContract,
    CONTRACTS,
    SettingsChangeServiceFactory
} from '@/core/contracts';
import { AuthServiceContract } from '@/core/contracts/authServiceContract';
import { AuthService } from '@/core/services/authService';
import { FetchServiceContract } from '@/core/contracts/fetchServiceContract';
import { FetchService } from '@/core/services/fetchService';
import { EventsServiceContract } from '@/core/contracts/eventsServiceContract';
import { EventsService } from '@/core/services/eventsService';
import { WindowsServiceContract } from '@/core/contracts/windowsServiceContract';
import { TilesService } from '@/core/services/tilesService';
import { StringsServiceContract } from '@/core/contracts/stringsServiceContract';
import { StringsService } from '@/core/services/stringsService';
import { SettingsChangeServiceContract } from './core/contracts/settingsChangeServiceContract';
import { SettingsChangeService } from './core/services/settingsChangeService';
import { ApiLayer } from './api/ApiLayer';
import { ConfigService } from './core/services/configService';
import { AuditService } from './core/services/auditService';

const container = new Container();

// Singletone services
container
    .bind<ConfigServiceContract>(CONTRACTS.ConfigService)
    .to(ConfigService)
    .inSingletonScope();
container
    .bind<AuthServiceContract>(CONTRACTS.AuthService)
    .to(AuthService)
    .inSingletonScope();
container
    .bind<FetchServiceContract>(CONTRACTS.FetchService)
    .to(FetchService)
    .inSingletonScope();
container
    .bind<EventsServiceContract>(CONTRACTS.EventsService)
    .to(EventsService)
    .inSingletonScope();
container
    .bind<WindowsServiceContract>(CONTRACTS.WindowsService)
    .to(TilesService)
    .inSingletonScope();
container
    .bind<StringsServiceContract>(CONTRACTS.StringsService)
    .to(StringsService)
    .inSingletonScope();
container
    .bind<AuditServiceContract>(CONTRACTS.AuditService)
    .to(AuditService)
    .inSingletonScope();

// Transient services
container
    .bind<SettingsChangeServiceContract>(CONTRACTS.SettingsChangeService)
    .to(SettingsChangeService)
    .inTransientScope();

// Factories
container
    .bind<SettingsChangeServiceFactory>(CONTRACTS.SettingsChangeServiceFactory)
    .toFactory<SettingsChangeServiceContract>((context: interfaces.Context) => {
        return () => {
            const service = context.container.get<
                SettingsChangeServiceContract
            >(CONTRACTS.SettingsChangeService);
            return service;
        };
    });

ApiLayer.register(container);

export default container;
